import { Rocket } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Rsvp({ datos, seccion, acciones }) {
  const rsvp = datos.rsvp || {};

  return (
    <section className="kx-seccion kx-rsvp" aria-label={seccion.titulo}>
      <div className="kx-seccion-interior">
        <EncabezadoSeccion p="kx" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="kx-titulo-rsvp" />
        <Reveal delay={0.1}>
          {rsvp.mensaje && <p className="kx-rsvp-mensaje">{rsvp.mensaje}</p>}
          {rsvp.fechaLimite && <p className="kx-rsvp-limite">{rsvp.fechaLimite}</p>}
          <button
            type="button"
            className="kx-boton kx-boton--claro"
            onClick={() => acciones?.onConfirmarAsistencia?.()}
            data-testid="kx-boton-rsvp"
          >
            <Rocket strokeWidth={2} />
            {rsvp.textoBoton || "Confirmar asistencia"}
          </button>
        </Reveal>
      </div>
    </section>
  );
}
